import { clientesKeys } from '@/features/clientes/utils'
import { selectRecuperarDocumentos } from '@/features/enviar-documentos/entities/select-recuperar-documentos'
import type { TEnvioDocumentosConfig } from '@/features/enviar-documentos/interfaces'
import { GetDocumentosLeadRepresadoService } from '@/features/enviar-documentos/services/get-documentos-lead-represado.service'

export const recuperarDocumentosLeadQueryOptions = (
  pessoaId: string,
): TEnvioDocumentosConfig['recuperarDocumentosQuery'] => ({
  gcTime: 0,
  staleTime: 0,
  queryKey: clientesKeys.documentosLeadRepresado(pessoaId),
  queryFn: async () => new GetDocumentosLeadRepresadoService().execute(pessoaId).then((response) => response.data),
  select: selectRecuperarDocumentos,
})
